module.exports = __webpack_public_path__ + "img/menu_icon04.96e8cce8.png";